// Note for Douglas -  /admin/free-sub-invite-u3a7oiMNxh95

import LoginPage from './views/Login';
import Page404 from 'views/Pages/404.js';
import ConnectionError from 'views/Pages/ConnectionError.js';
import UserError from 'views/Pages/UserError.js';
import ProjectRedirect from './views/Admin/Staffing/ProjectRedirect';

//staffing views
import Staffing from './views/Admin/Staffing/Staffing';
import ContractorDashboard from './views/Admin/Staffing/ContractorDashboard';

// @material-ui/icons
import PeopleIcon from '@material-ui/icons/People';
import WorkIcon from '@material-ui/icons/Work';
import ProjectIcon from '@material-ui/icons/Assignment';
import ScheduleIcon from '@material-ui/icons/AssignmentInd';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import BusinessIcon from '@material-ui/icons/Business';

var dashRoutes = [
  {
    path: '/companies',
    name: 'Companies',
    icon: BusinessIcon,
    component: Staffing,
    layout: '/admin/staffing',
    staffingAdminRoute: true,
  },
  {
    path: '/deals',
    name: 'Deals',
    icon: WorkIcon,
    component: Staffing,
    layout: '/admin/staffing',
    staffingAdminRoute: true,
  },
  {
    path: '/projects',
    name: 'Projects',
    icon: ProjectIcon,
    component: Staffing,
    layout: '/admin/staffing',
    staffingAdminRoute: true,
  },
  {
    path: '/contractors',
    name: 'Staff',
    icon: PeopleIcon,
    component: Staffing,
    layout: '/admin/staffing',
    staffingAdminRoute: true,
  },
  {
    path: '/schedules',
    name: 'Schedules',
    icon: ScheduleIcon,
    component: Staffing,
    layout: '/admin/staffing',
    staffingAdminRoute: true,
  },
  {
    path: '/project-redirect/:projectId',
    name: 'Project Redirect',
    component: ProjectRedirect,
    layout: '/admin',
    hideInSidebar: true,
  },
  {
    path: '/contractor/',
    name: 'My Projects',
    icon: WorkIcon,
    component: ContractorDashboard,
    layout: '/admin',
    vCContractorRoute: true,
    isNewSection: true,
  },
  {
    path: '/contractor-info/',
    name: 'My Info',
    icon: AccountBoxIcon,
    component: ContractorDashboard,
    layout: '/admin',
    vCContractorRoute: true,
  },
  {
    path: '/contractor-availability/',
    name: 'My Availability',
    icon: CalendarTodayIcon,
    component: ContractorDashboard,
    layout: '/admin',
    vCContractorRoute: true,
  },
];

export const pageRoutes = [
  {
    path: '/login-page',
    name: 'Login Page',
    component: LoginPage,
    layout: '/auth',
  },
  {
    path: '/404',
    name: 'Not Found',
    component: Page404,
    layout: '/auth',
  },
  {
    path: '/connection-error',
    name: "Can't Connect",
    component: ConnectionError,
    layout: '/auth',
  },
  {
    path: '/user-error',
    name: 'User Error',
    component: UserError,
    layout: '/auth',
  },
];

export default dashRoutes;
